export function MetricCard({
    label,
    value,
    detail,
}) {

    return (
        <div className="rounded-2xl border border-slate-800 bg-slate-900/70 p-4 shadow-xl shadow-black/10">

            <p className="text-xs font-medium uppercase tracking-wider text-slate-500">
                {label}
            </p>

            <p className="mt-2 text-xl font-semibold text-slate-100">
                {value}
            </p>

            {detail ? (
                <p className="mt-1 text-xs text-slate-500">
                    {detail}
                </p>
            ) : null}

        </div>
    );
}